import "./innerChaos.scss";
import "../perfume.scss";

// Images
// import MainImage from "../../../assets/img/perfume/inner_chaos_main.webp";
import ConcentrationImage from "../../../assets/img/perfume/inner_chaos_concentration.webp";
import Ingredients1 from "../../../assets/img/perfume/ingredients/orange-blossom.webp";
import Ingredients2 from "../../../assets/img/perfume/ingredients/pear.webp";
import Ingredients3 from "../../../assets/img/perfume/ingredients/pink-pepper.webp";
import Ingredients4 from "../../../assets/img/perfume/ingredients/coffee-beans.webp";
import Ingredients5 from "../../../assets/img/perfume/ingredients/jasmine.webp";
import Ingredients6 from "../../../assets/img/perfume/ingredients/bitter-almond.webp";
import Ingredients7 from "../../../assets/img/perfume/ingredients/cashmere-wood.webp";
import Ingredients8 from "../../../assets/img/perfume/ingredients/dark-oily-vanilla-beans-emer.webp";
import Details from "../components/details/Details";
import productStore from "../../../store/productStore";
import { useEffect, useState } from "react";
import ProductReview from "../components/productReview/ProductReview";
// import ProductSlider from "../components/productSlider/ProductSlider";
import Ingredients from "../components/ingredients/Ingredients";
// import FirstContent from "../components/firstContent/FirstContent";
import Concentration from "../components/concentration/Concentration";
import SEO from "components/seo/SEO";
import { INNER_CHAOS_ID } from "../../../constant";

import MainVideoWEBM from "assets/video/perfume/inner_chaos/inner_chaos_webBG.webm";
// import MainVideoMobWEBM from "assets/video/perfume/inner_chaos/inner_chaos_mob.webm";
import MainVideoMobWEBM from "assets/video/perfume/inner_chaos/inner_chaos_mobBG.webm";
import sliderImage1 from "assets/img/perfume/slider/posttrioswipe1ic.webp";
import sliderImage2 from "assets/img/perfume/slider/posttrioswipe2ic.webp";
import VideoWithEndImageNew from "../components/videoWithEndImage/VideoWithEndImageNew";
import ProductSliderNew from "../components/productSlider/ProductSliderNew";
import imageLoadStore from "store/imageLoadStore";
import MyLoader from "components/myLoader/MyLoader";

const InnerChaos = () => {
  const ImageLoadStore = imageLoadStore();
  const ProductStore = productStore();
  const [product, setProduct] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const AccordionDetails = [
    {
      label: "DESCRIPTION",
      content: (
        <div>
          A sweet, addictive coffee-vanilla fragrance with a bold personality.
          Inner Chaos opens with pear and pink pepper for a bright and slightly
          spicy introduction. The heart reveals rich coffee, jasmine, bitter
          almond, and licorice — creating a warm and captivating aroma. The base
          of vanilla, patchouli, cedarwood, and cashmere wood adds creamy depth
          and sensual warmth.
          <br />
          <br />
          This gourmand perfume is perfect for those who love sweet yet edgy
          scents that stand out.
        </div>
      ),
    },
    {
      label: "FRAGRANCE NOTES",
      content: (
        <p>
          <strong>Top Notes: </strong>Pink Pepper, Orange Blossom, Pear
          <br />
          <strong>Middle Notes: </strong>Coffee, Jasmine, Bitter Almond,
          Licorice
          <br />
          <strong>Base Notes: </strong>Vanilla, Patchouli, Cedarwood, Cashmere
          Wood
        </p>
      ),
    },
    {
      label: "FEELINGS",
      content: <p>Seductive • Addictive • Warm • Mysterious • Glamorous</p>,
    },
    {
      label: "OCCASIONS",
      content: (
        <ol>
          <li>Night Outs</li>
          <li>Romantic Dates</li>
          <li>Parties</li>
          <li>Cool Weather</li>
        </ol>
      ),
    },
    {
      label: "BEHIND THE PERFUME",
      content: (
        <p>
          Inner Chaos blends sweetness with depth. The coffee-vanilla base
          creates an irresistible warmth, while patchouli and woods add balance.
          It’s bold, modern, and designed to leave a lasting impression.
        </p>
      ),
    },
    {
      label: "SHIPPING & RETURN",
      content: (
        <p>
          We carefully pack and dispatch all orders to ensure safe delivery.
          Orders are processed within standard business timelines.
          <br />
          <strong>Please note:</strong> Due to hygiene and product safety
          reasons, we do not accept returns or exchanges once the product has
          been delivered.
        </p>
      ),
    },
    {
      label: "LEGAL INFORMATION",
      content: (
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <div>
            <p style={{ fontWeight: 700 }}>Marketed by KRISTIVE</p>
            <p>
              105, Shubham Residency 1, Navagam Surat 394210, Gujarat, India
            </p>
          </div>
          <div>
            <p>
              <strong>Customer Care:</strong>
            </p>
            <p>
              <strong>Email</strong> - support@kristive.com
            </p>
            <p>
              <strong>Call</strong> - +91 81601 92573
            </p>
            <p>
              <strong>Website</strong> - www.kristive.com
            </p>
          </div>
          <div>
            <p>
              <strong>Manufactured by</strong>
            </p>
            <p>
              MINATI ESSENTIALS 8, Laxmi Narayan Industries, Udhna Surat,
              Gujarat - 394210
            </p>
            <strong>Lic. No.: </strong>GC/2055
          </div>
          <div>
            <p>
              <strong>Country of Origin:</strong> India
            </p>
            <p>
              <strong>Net Contents:</strong> 50ML / 1.7 fl. oz
            </p>
          </div>
          <div>
            <p>
              <strong>Ingredients:</strong>
            </p>
            <p>
              Linalool, Geraniol, Limonene, Eugenol, Denatured Ethyl Alcohol,
              Fragrance Oil.
            </p>
          </div>

          <div>
            <p>For External Use Only.</p>
            <p>Store in a Cool & Dry Place.</p>
          </div>

          <div>
            <p>
              <strong>Usage:</strong>
            </p>
            <p>
              To avoid staining, spray perfume from a safe distance of 15-20 cm.
            </p>
          </div>
          <div>
            <p>
              <strong>Warning:</strong>
            </p>
            <p>Keep away from children and pets.</p>
            <p>Avoid contact with eyes, mouth, and broken skin.</p>
            <p>Flammable - Keep away from heat, sparks, and open flame.</p>
          </div>

          <div>
            <p>
              <strong>Generic Name:</strong> Perfume
            </p>
            <p>Best Before: 36 months from manufacturing date.</p>
          </div>
        </div>
      ),
    },
  ];

  useEffect(() => {
    window.scrollTo({ top: 0 });
    fetchSpecificProductRating();
    if (ImageLoadStore.imageLoading) {
      setTimeout(() => {
        document.body.style.overflowY = "hidden";
      }, 50);
    }
  }, []);

  const fetchSpecificProductRating = async () => {
    setIsLoading(true);
    const product = await ProductStore.fetchOneProduct({
      _id: INNER_CHAOS_ID,
    });
    setProduct(product);
    setIsLoading(false);
  };

  return (
    <>
      <SEO
        title="Inner Chaos Perfume | Sweet Coffee Vanilla Gourmand Scent"
        description="Inner Chaos blends rich coffee, creamy vanilla, and warm woods into a sweet, addictive gourmand perfume. Perfect for evening wear and special moments."
      />
      {ImageLoadStore.imageLoading && (
        <div className="loading">
          <MyLoader height="100vh" />
        </div>
      )}
      <div className="perfume-details inner-chaos">
        <VideoWithEndImageNew
          websiteVideoWEBM={MainVideoWEBM}
          mobileVideoWEBM={MainVideoMobWEBM}
          product={product}
          slogan="Beautifully Addictive. Wildly You."
        />
        <ProductSliderNew images={[sliderImage1, sliderImage2]} />

        <div className="content">
          {/* <FirstContent
            title={"INNER CHAOS"}
            shortDescription={"Disrupt the Ordinary"}
            image={MainImage}
            id={INNER_CHAOS_ID}
            productName={product?.productName || ""}
            regularPrice={product?.regularPrice || ""}
            salePrice={product?.salePrice || null}
          />

          {product?.productImages.length > 0 && (
            <ProductSlider images={product?.productImages || []} />
          )} */}

          <Ingredients
            Ingredients1={{
              img: Ingredients1,
              name: "Orange Blossom",
              desc: "Sweet white floral with a radiant, luminous touch",
            }}
            Ingredients2={{
              img: Ingredients2,
              name: "Pear",
              desc: "Juicy, sweet fruitiness with a fresh smooth feel",
            }}
            Ingredients3={{
              img: Ingredients3,
              name: "Pink Pepper",
              desc: "Soft spicy kick with a bright, sparkling warmth",
            }}
            Ingredients4={{
              img: Ingredients4,
              name: "Coffee",
              desc: "Dark, rich aroma adding bold addictive depth",
            }}
            Ingredients5={{
              img: Ingredients5,
              name: "Jasmine",
              desc: "Soft, sensual floral with a creamy elegance",
            }}
            Ingredients6={{
              img: Ingredients6,
              name: "Bitter Almond",
              desc: "Sweet-bitter nuttiness with a warm gourmand edge",
            }}
            Ingredients7={{
              img: Ingredients7,
              name: "Cashmere Wood",
              desc: "Soft, musky wood with a warm, velvety feel",
            }}
            Ingredients8={{
              img: Ingredients8,
              name: "Vanilla",
              desc: "Creamy sweetness with a warm, comforting allure",
            }}
          />

          <Concentration
            image={ConcentrationImage}
            percentage={25}
            shortDescription={
              "Elegant Blend of Fruity Freshness and Deep Floral Richness"
            }
          />

          <Details items={AccordionDetails} />

          <ProductReview
            isLoading={isLoading}
            averageRating={product?.averageRating || 0}
            totalReview={product?.ratingCount || 0}
            ratings={product?.ratings || []}
            particularRatings={{
              fiveStar: product?.fiveStar,
              fourStar: product?.fourStar,
              threeStar: product?.threeStar,
              twoStar: product?.twoStar,
              oneStar: product?.oneStar,
            }}
            appBarColor={"#663b1b"}
          />
        </div>
      </div>
    </>
  );
};

export default InnerChaos;
